import React from "react";
import { DataPipeline } from "model/data_pipeline";
import * as utils from "resources/utils"
import "./index.css";

interface DataPipelineItemProps {
  dataPipelineData: DataPipeline;
}

const displaySchedule = (dataPipline: DataPipeline) => {
  if (dataPipline.schedule_time === 'on_demand' || dataPipline.schedule_time === null) {
    return 'On Demand'
  } else if (dataPipline.schedule_time === 'custom' && dataPipline.extra_config?.custom_schedule) {
    return dataPipline.extra_config?.custom_schedule
  } else {
    return dataPipline.schedule_time
  }
}

export default function DataPipelineItem({
  dataPipelineData,
}: DataPipelineItemProps) {
  return (
    <tr className="data-pipeline-item">
      <th scope="row">{utils.default.renderStatusIcon(dataPipelineData.status)}</th>
      <td>
        <a href={`/data_pipeline/view/${dataPipelineData?.id}`}>
          <span className="data-pipeline-item__name">{dataPipelineData?.name}</span>
        </a>
        <br/>
        <span className="data-pipeline-item__label">{dataPipelineData?.owner}</span>
        <span className="data-pipeline-item__label">{dataPipelineData?.data_pipeline_template_name}</span>
      </td>
      <td className="data-pipeline-item__info">{displaySchedule(dataPipelineData)}</td>
      <td className="data-pipeline-item__info">{dataPipelineData?.last_run_display}</td>
      <td className="data-pipeline-item__info">{dataPipelineData?.next_run}</td>
    </tr>
  );
}
